/* Bundle Builder — native tier bundle widget.
 *
 * Reads its configuration from a JSON script tag (#bundle-builder-config) that
 * Liquid renders, mounts into #bundle-builder, and builds the whole cart in one
 * /cart/add.js request.
 *
 * No app, no external dependencies, no iframe.
 *
 * Tier totals are charged by AUTOMATIC Shopify discounts scoped to the product
 * with a minimum-quantity requirement. This file deliberately does NOT apply
 * discount codes: a code has to be applied by redirecting through
 * /discount/<CODE>, and a code already attached to the session is not reliably
 * replaced when the shopper changes tiers. Automatic discounts carry no session
 * state and are evaluated server-side on every cart.
 */
(function () {
  'use strict';

  var MOUNT_ID = 'bundle-builder';
  var CONFIG_ID = 'bundle-builder-config';

  var root, cfg, state = { tier: 0, picks: [], addons: {} };

  function money(cents) {
    var c = Math.round(cents);
    return cfg.moneyFormat
      ? cfg.moneyFormat.replace('{{amount}}', (c / 100).toFixed(2))
      : '$' + (c / 100).toFixed(2);
  }

  function tier() { return cfg.tiers[state.tier]; }

  function total() {
    var sum = tier().price;
    (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) sum += a.price; });
    return sum;
  }

  function unitOptions(selected) {
    return cfg.variants.map(function (v) {
      return '<option value="' + v.id + '"' +
        (String(v.id) === String(selected) ? ' selected' : '') +
        (v.available ? '' : ' disabled') + '>' +
        v.title + (v.available ? '' : ' — sold out') + '</option>';
    }).join('');
  }

  function render() {
    var html = '';
    if (cfg.label) html += '<p class="bbdl__label">' + cfg.label + '</p>';

    cfg.tiers.forEach(function (tr, i) {
      var on = i === state.tier;

      html += '<div class="bbdl__tier' + (on ? ' is-on' : '') + '" data-tier="' + i + '">';

      html += '<label class="bbdl__head">';
      html += '<input type="radio" class="bbdl__radio" name="bbdl-tier" value="' + i + '"' + (on ? ' checked' : '') + '>';
      html += '<span class="bbdl__ht"><span class="bbdl__title">' + tr.title + '</span>';
      if (tr.subtitle) html += '<span class="bbdl__sub">' + tr.subtitle + '</span>';
      html += '</span>';
      html += '<span class="bbdl__pr"><span class="bbdl__price">' + money(tr.price) + '</span>';
      if (tr.compareAt && tr.compareAt > tr.price) html += '<span class="bbdl__was">' + money(tr.compareAt) + '</span>';
      html += '</span></label>';

      html += '<div class="bbdl__body">';

      // One variant picker per unit in the tier, so a 3-pack can be three
      // different variants. Skipped entirely for single-variant products.
      if (cfg.variants.length > 1) {
        for (var u = 0; u < tr.qty; u++) {
          html += '<div class="bbdl__pick">';
          html += '<div class="bbdl__pickLabel">' +
            (tr.qty > 1 ? (cfg.unitWord || 'Item') + ' ' + (u + 1) : (cfg.pickLabel || 'Choose')) +
            '</div>';
          html += '<select class="bbdl__select" data-unit="' + u + '">' + unitOptions(state.picks[u]) + '</select>';
          html += '</div>';
        }
      }

      if (cfg.addons && cfg.addons.length) {
        html += '<div class="bbdl__addons">';
        cfg.addons.forEach(function (a) {
          html += '<label class="bbdl__addon">';
          html += '<input type="checkbox" class="bbdl__cb" data-addon="' + a.id + '"' +
            (state.addons[a.id] ? ' checked' : '') + '>';
          if (a.image) html += '<img class="bbdl__thumb" src="' + a.image + '" alt="" loading="lazy">';
          html += '<span class="bbdl__an">+ ' + a.title + '</span>';
          html += '<span class="bbdl__ap">' + money(a.price);
          if (a.compareAt && a.compareAt > a.price) html += '<s>' + money(a.compareAt) + '</s>';
          html += '</span></label>';
        });
        html += '</div>';
      }

      html += '</div></div>';
    });

    html += '<div class="bbdl__total"><span>' + (cfg.totalLabel || 'Total') + '</span><b data-total></b></div>';
    html += '<button type="button" class="bbdl__cta">' + (cfg.ctaLabel || 'Add to cart') + '</button>';
    html += '<p class="bbdl__err">' + (cfg.errorText || 'This item may be unavailable. Please try again.') + '</p>';

    root.innerHTML = html;
    paintTotal();
  }

  function paintTotal() {
    var el = root.querySelector('[data-total]');
    if (el) el.textContent = money(total());
  }

  function ready() {
    if (cfg.variants.length <= 1) return cfg.variants.length === 1 && cfg.variants[0].available;
    var t = tier();
    for (var i = 0; i < t.qty; i++) if (!state.picks[i]) return false;
    return true;
  }

  function onChange(e) {
    var el = e.target;

    if (el.name === 'bbdl-tier') {
      state.tier = parseInt(el.value, 10);
      render();
      return;
    }
    if (el.hasAttribute('data-unit')) {
      state.picks[parseInt(el.getAttribute('data-unit'), 10)] = el.value;
      root.classList.remove('has-error');
      return;
    }
    if (el.hasAttribute('data-addon')) {
      state.addons[el.getAttribute('data-addon')] = el.checked;
      paintTotal();
    }
  }

  function addToCart() {
    var btn = root.querySelector('.bbdl__cta');

    if (!ready()) { root.classList.add('has-error'); return; }
    root.classList.remove('has-error');
    btn.disabled = true;

    var t = tier(), items = [], counts = {};

    // Collapse repeated picks into one line each, so a 3-pack of the same
    // variant is one line of quantity 3 rather than three lines of 1.
    if (cfg.variants.length > 1) {
      for (var i = 0; i < t.qty; i++) counts[state.picks[i]] = (counts[state.picks[i]] || 0) + 1;
    } else {
      counts[cfg.variants[0].id] = t.qty;
    }
    Object.keys(counts).forEach(function (id) {
      items.push({ id: Number(id), quantity: counts[id] });
    });
    (cfg.addons || []).forEach(function (a) {
      if (state.addons[a.id]) items.push({ id: Number(a.id), quantity: 1 });
    });

    fetch(cfg.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok || data.status >= 400) throw new Error(data.description || data.message || 'Could not add items. Please try again.'); return data; }); })
      .then(function () {
        window.location.href = cfg.afterAdd === 'cart' ? cfg.routes.cart : cfg.routes.checkout;
      })
      .catch(function (error) {
        root.querySelector('.bbdl__err').textContent = error.message || 'Could not add items. Please try again.';
        btn.disabled = false;
        root.classList.add('has-error');
      });
  }

  function boot() {
    root = document.getElementById(MOUNT_ID);
    var node = document.getElementById(CONFIG_ID);
    if (!root || !node) return;

    try { cfg = JSON.parse(node.textContent); } catch (e) { return; }
    if (!cfg.tiers || !cfg.tiers.length) return;
    if (!cfg.variants || !cfg.variants.length) return;

    var first = cfg.variants.filter(function (v) { return v.available; })[0] || cfg.variants[0];
    var maxQty = cfg.tiers.reduce(function (m, t) { return Math.max(m, t.qty); }, 1);
    state.picks = new Array(maxQty).fill(first.id);
    (cfg.addons || []).forEach(function (a) { state.addons[a.id] = !!a.checked; });

    root.classList.add('bbdl');
    render();

    root.addEventListener('change', onChange);
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.bbdl__cta')) addToCart();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
